<div class="layout-footer" style="padding-left: 20%;">
    <!-- <img src="assets/layout/images/norm-logo.png" alt="Logo" height="50" style="margin: -1rem;" /> -->

    <span class="font-medium ml-2">&#64;{{ date}} Norm Dijital  </span>
</div>
